import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { IComponentInfo, TDateTimeMode, TComponentName } from "./types/index";
import {
	defaultOption,
	ISummaryComponentInfo,
	testComponentData,
} from "./component/SummaryCard/SummaryCard.fixtures";
import { OrderModule } from "./modules/OrderModule/OrderModule";

declare global {
	/* eslint-disable no-var */
	var renderReactComponent: (
		componentInfo: IComponentInfo,
		timeMode?: TDateTimeMode,
	) => any;
	var getUserDetails: () => unknown;
	var dataSource: string;
	var renderOrderModule: (id: string) => void;
	/* eslint-enable no-var */
}

switch (process.env.NODE_ENV) {
	case "production":
		console.log("React Order Module initialized");
		window.renderReactComponent = (
			componentInfo: IComponentInfo,
			timeMode?: TDateTimeMode,
		) => {
			const container = document.getElementById(componentInfo.id);
			if (!container) return null;
			//ReactDOM.render is deprecated in react in React 18
			const root = createRoot(container);
			root.render(
				<React.StrictMode>
					<App componentInfo={componentInfo} timeMode={timeMode} />
				</React.StrictMode>,
			);
			return root;
		};

		window.renderOrderModule = (id: string) => {
			const container = document.getElementById(id);
			if (!container) return null;
			const root = createRoot(container);
			root.render(
				<React.StrictMode>
					<OrderModule />
				</React.StrictMode>,
			);
			return root;
		};
		break;

	case "development":
		const componentInfo = {
			id: "root",
			type: "MO-WGT-DATA-VIEW-TABS" as TComponentName,
			config: defaultOption,
			data: testComponentData,
		} as ISummaryComponentInfo;
		const timeMode = "TODAY";


		const container = document.getElementById("root");
		if (container) {
			const root = createRoot(container);
			root.render(
				<React.StrictMode>
					<OrderModule />
				</React.StrictMode>,
			);
		}

		window.renderReactComponent = (
			componentInfo: IComponentInfo,
			timeMode?: TDateTimeMode,
		) => {
			const container = document.getElementById(componentInfo.id);
			if (!container) return null;
			const root = createRoot(container);
			root.render(
				<React.StrictMode>
					<App componentInfo={componentInfo} timeMode={timeMode} />
				</React.StrictMode>,
			);
			return root;
		};

		window.renderOrderModule = (id: string) => {
			const container = document.getElementById(id);
			if (!container) return null;
			const root = createRoot(container);
			root.render(
				<React.StrictMode>
					<OrderModule />
				</React.StrictMode>,
			);
			return root;
		};
		break;
	default:
		window.renderReactComponent = (
			componentInfo: IComponentInfo,
			timeMode?: TDateTimeMode,
		) => {
			const container = document.getElementById(componentInfo.id);
			if (!container) return null;
			const root = createRoot(container);
			root.render(
				<React.StrictMode>
					<App componentInfo={componentInfo} timeMode={timeMode} />
				</React.StrictMode>,
			);
			return root;
		};

		window.renderOrderModule = (id: string) => {
			const container = document.getElementById(id);
			if (!container) return null;
			const root = createRoot(container);
			root.render(
				<React.StrictMode>
					<OrderModule />
				</React.StrictMode>,
			);
			return root;
		};
		console.log("environment not supported", process.env.NODE_ENV);
		
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();